export class StateIndicatorComponent {

    static template = `
        <div id="state-indicator-container" style="display:none" ng-class="state&&('state-'+state)" ng-style="{ display: message?'':'none' }"></div>
    `;
	
	static $inject = ["stateIndicatorService","$rootScope","$scope","$timeout","$sce","$injector","$compile","gettextCatalog","HUDService","$element" ]; // jshint ignore:line

	constructor( stateIndicatorService, $rootScope,  $scope,  $timeout,  $sce,  $injector,  $compile,  gettextCatalog,  HUDService, $element ) {

        this.$element = $element;

		$scope.HUD = HUDService;
		$scope.state = null;
        
		var origMessage;

		stateIndicatorService.setHtml = ( message = null, scope = null, state = null ) => {
			message = message || null;

			if (origMessage == message) return;
			
			if (origMessage = message) { 
				$scope.entitySelectionService = $injector.get('entitySelectionService');

				$scope.state = state;
				$scope.scope = scope || $scope;
				$scope.html = "<div>"+gettextCatalog.getString( message, scope )+"<div>";
				$scope.message = $sce.trustAsHtml( $scope.html );

                let dom = $scope.html;

                try {
                    let _$scope_ = $scope.$new( true );

                    if (scope) angular.extend( _$scope_, scope );

                    dom = $compile( $scope.html )( _$scope_ );

                } catch (error) {
                    console.error( error )
                }

                this.setDom( dom );

				return $timeout(function() {
					$scope.setIndicatorSize();
				});
			} else return $scope.clear();
		};

		stateIndicatorService.clear = function clearStateIndicator() {
			return $timeout(function(){
				$scope.message = origMessage = null;
				$scope.setIndicatorSize();
			});
		};

		(function( elem, oelem, celem ){
			$scope.$watch(function(){
				if (oelem = oelem || document.getElementById( "oeuvres-list"   )) $rootScope.__oeuvrePanelHeight = oelem.clientHeight;
				if (celem = celem || document.getElementById( "controls-panel" )) $rootScope.__controlPanelWidth = celem.clientWidth;
				return $rootScope.__oeuvrePanelHeight+"-"+$rootScope.__controlPanelWidth || 0;
			}, function(){
				setTimeout(function(){
					$scope.setIndicatorSize();
				});
			});

			$scope.setIndicatorSize = function setIndicatorSize( force ){
				if (force || $scope.message) {
					elem = elem || document.getElementById("state-indicator-container");
					elem.style.left = celem.clientWidth  + "px";
					elem.style.top  = oelem.clientHeight + "px";
				}
			}
		})();
	}

    setDom( dom ) {

        let content = $("<span>").append( dom )

        $( "#state-indicator-container", this.$element ).html( content );

    }

    onClick( event ) {
        debugger;
    }
}


export const AjsStateIndicatorComponent = {
    template: StateIndicatorComponent.template,
    controller: StateIndicatorComponent
}